import FilterText from './filterText'

export default FilterText
